import React, { useContext, useEffect, useState } from "react";
import { Grid, TextField, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

// Components

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    height: "62.28px",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const DashboardForm_03 = () => {
  const classes = useStyles();

  const { selected_profile, selected_fb_details } = useContext(
    FacebookProfilesDashboardContext
  );

  const [timezone, setTimezone] = useState("");

  useEffect(() => {
    const ad_accounts = selected_profile.ad_account;
    let timezone = "";

    for (let x in ad_accounts) {
      if (ad_accounts[x].ad_account_id === selected_fb_details.ad_account) {
        timezone = ad_accounts[x].ad_account_timezone_name;
        break;
      }
    }

    setTimezone(timezone);
  }, [selected_fb_details.ad_account]);

  return (
    // 3rd Column
    <Grid item xs={4} container direction="column" spacing={1}>
      <Grid item className={classes.title}>
        {" "}
      </Grid>
      <Grid item>
        <TextField
          fullWidth
          size="small"
          margin="dense"
          label="Timezone"
          id="timezone"
          name="timezone"
          disabled={true}
          value={timezone ? timezone : ""}
        />{" "}
      </Grid>
      {/* Shopify */}{" "}
      {/* <Grid item className={classes.title}>
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                      Shopify
                    </Typography>
                  </Grid> */}
      {/* Pages */}{" "}
      {/* <Grid item>
                    <TextField
                      fullWidth
                      select
                      SelectProps={{ native: true }}
                      size="small"
                      margin="dense"
                      label="Pages"
                      id="pages"
                      name="pages"
                      // value={}
                      // onChange={}
                      // error={}
                      // helperText={}
                    >
                      <option value="select" disabled>
                        --- select one---
                      </option>
                      <option value="Page 1">Page 1</option>
                      <option value="Page 2">Page 2</option>
                      <option value="Page 3">Page 3</option>
                    </TextField>
                  </Grid> */}
      {/* Upload Video */}{" "}
      {/* <Grid item>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      className={classes.button}
                    >
                      Upload Video
                    </Button>
                  </Grid> */}{" "}
    </Grid>
  );
};

export default DashboardForm_03;
